import { render } from "./PlaylistEmptyPlaceholder.vue?vue&type=template&id=07eca9d6"
import script from "./PlaylistEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Playlist/PlaylistEmptyPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07eca9d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07eca9d6', __exports__)) {
    api.reload('07eca9d6', __exports__)
  }
  
  module.hot.accept("./PlaylistEmptyPlaceholder.vue?vue&type=template&id=07eca9d6", () => {
    api.rerender('07eca9d6', render)
  })

}


export default __exports__